module.exports = __webpack_public_path__ + "img/240301b_bs_document-video-icon.ae063358.svg";